import { useRef } from "react";

import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
} from "chart.js";

import {
  BoxPlotController,
  BoxAndWiskers
} from "@sgratzl/chartjs-chart-boxplot";

import { Chart } from "react-chartjs-2";

import ChartToolbar from "./ChartToolbar";


// Register the Chart.js components required for the boxplot.
ChartJS.register(
  BoxPlotController,
  BoxAndWiskers,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);


function EnergyBoxplotChart({
  data = [],
  chargerType = "Both"
}) {
  const chartRef = useRef(null);


  // Determine which charger types should be displayed.
  const showAC = chargerType === "Both" || chargerType === "AC";
  const showDC = chargerType === "Both" || chargerType === "DC";


  // Extract valid AC energy values from the API data.
  const acValues = data
    .filter(
      (row) =>
        row.chargerType === "AC" &&
        !Number.isNaN(Number(row.energy))
    )
    .map((row) => Number(row.energy));


  // Extract valid DC energy values from the API data.
  const dcValues = data
    .filter(
      (row) =>
        row.chargerType === "DC" &&
        !Number.isNaN(Number(row.energy))
    )
    .map((row) => Number(row.energy));


  // Build the boxplot data based on the selected charger filter.
  const labels = [];
  const boxplotData = [];


  if (showAC) {
    labels.push("AC");
    boxplotData.push(acValues);
  }


  if (showDC) {
    labels.push("DC");
    boxplotData.push(dcValues);
  }


  const chartData = {
    labels,
    datasets: [
      {
        label: "Energy per charge",
        data: boxplotData,
        borderWidth: 2
      }
    ]
  };


  // Configure the boxplot axes, legend and tooltip.
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    interaction: {
      mode: "nearest",
      intersect: true
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Energy (kWh)"
        }
      },
      x: {
        title: {
          display: true,
          text: "Charger Type"
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "right",
        labels: {
          boxWidth: 14,
          boxHeight: 14,
          padding: 14
        }
      },
      tooltip: {
        enabled: true
      }
    }
  };


  return (
    <article className="chart-card">
      <div className="chart-card-header">
        <div className="chart-card-title">
          <h2>Amount of Energy Used per Charge</h2>

          <p>
            Distribution of energy delivered per charging session.
          </p>
        </div>


        <ChartToolbar
          chartRef={chartRef}
          title="Amount of Energy Used per Charge"
          enableZoom={false}
        />
      </div>


      {/* Render the energy distribution boxplot */}
      <div className="chart-canvas-container">
        <Chart
          ref={chartRef}
          type="boxplot"
          data={chartData}
          options={options}
        />
      </div>
    </article>
  );
}


export default EnergyBoxplotChart;